import React from 'react'



function ContentContainer(props) {
    return <div>{props.children}</div>
}

export default ContentContainer